"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = emitTypingIndicator;
exports.EMIT_TYPING_INDICATOR = void 0;
var EMIT_TYPING_INDICATOR = 'WEB_CHAT/EMIT_TYPING_INDICATOR';
exports.EMIT_TYPING_INDICATOR = EMIT_TYPING_INDICATOR;

function emitTypingIndicator() {
  return {
    type: EMIT_TYPING_INDICATOR
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9hY3Rpb25zL2VtaXRUeXBpbmdJbmRpY2F0b3IuanMiXSwibmFtZXMiOlsiRU1JVF9UWVBJTkdfSU5ESUNBVE9SIiwiZW1pdFR5cGluZ0luZGljYXRvciIsInR5cGUiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQSxJQUFNQSxxQkFBcUIsR0FBRyxnQ0FBOUI7OztBQUVlLFNBQVNDLG1CQUFULEdBQStCO0FBQzVDLFNBQU87QUFDTEMsSUFBQUEsSUFBSSxFQUFFRjtBQURELEdBQVA7QUFHRCIsInNvdXJjZVJvb3QiOiJjb3JlOi8vLyIsInNvdXJjZXNDb250ZW50IjpbImNvbnN0IEVNSVRfVFlQSU5HX0lORElDQVRPUiA9ICdXRUJfQ0hBVC9FTUlUX1RZUElOR19JTkRJQ0FUT1InO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBlbWl0VHlwaW5nSW5kaWNhdG9yKCkge1xuICByZXR1cm4ge1xuICAgIHR5cGU6IEVNSVRfVFlQSU5HX0lORElDQVRPUlxuICB9O1xufVxuXG5leHBvcnQgeyBFTUlUX1RZUElOR19JTkRJQ0FUT1IgfTtcbiJdfQ==